// Plantilla 4 de notaría, «editorial» (ref: https://trello.com/c/XU15s9gl)
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../store/index'
import { useUtils } from '#imports'
import { t as tSolicitud } from './solicitudTextos'
import { tituloSeccion, textoPlano } from './useNotaria2'

/**
 * Secciones de la portada que se ven (mismos interruptores y filtros que cada bloque), en orden.
 * Da el sumario de la portada y el número de cada sección («01 Palabras del notario»).
 */
export function useSumario() {
  const store = useStore()
  const { NOTARIA } = storeToRefs(store)
  const { $t } = useUtils()

  const secciones = computed(() => {
    const N = NOTARIA.value ?? {}
    const H = N.Theme?.Home ?? {}
    const titulo = (bloque: any, defecto: string) => textoPlano(bloque?.Titulo?.Texto || '') || defecto
    return [
      H.PN?.Mostrar && { ancla: 'about', texto: titulo(H.PN, tituloSeccion(N, 'Notario', $t)) },
      H.Servicios?.Mostrar && (N.Servicios ?? []).some((s: any) => s.Publicado && s.MostrarHome)
        && { ancla: 'service', texto: titulo(H.Servicios, tituloSeccion(N, 'Servicios', $t)) },
      H.Blog?.Mostrar && (N.Blog ?? []).some((a: any) => a.Publicado && a.MostrarHome && a.Imagen)
        && { ancla: 'blog', texto: titulo(H.Blog, tituloSeccion(N, 'Blog', $t)) },
      H.Testimonios?.Mostrar && N.Testimonios?.length && { ancla: 'testimonial', texto: tSolicitud('Opiniones') },
      H.Gallery?.Mostrar && { ancla: 'homegallery', texto: titulo(H.Gallery, tituloSeccion(N, 'Gallery', $t)) },
      { ancla: 'contact', texto: tituloSeccion(N, 'Contacto', $t) },
    ].filter(Boolean) as { ancla: string, texto: string }[]
  })

  /** «01», «02»… según la posición de la sección entre las visibles. */
  function numero(ancla: string): string {
    const i = secciones.value.findIndex(s => s.ancla === ancla)
    return i < 0 ? '' : String(i + 1).padStart(2, '0')
  }

  return { secciones, numero }
}
